import React, { useEffect } from 'react';
import { Row, Col, Container, Alert } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Form, Field } from '@availity/form';
import * as yup from 'yup';
import '@availity/yup';
import * as authActions from '../../store/auth/actions';
import heroImg from '../../assets/images/doctor-real-on-phone-male-couple.webp';
import logo from '../../assets/images/logo-dark.png';
import Footer from '../../components/Authentication/Footer';

const INITIAL_VALUES =
  process.env.REACT_APP_ENVIRONMENT === 'dev'
    ? {
        email: 'enrico.bianchi17@mediadatafactory.com',
        password: 'password',
      }
    : {};

const Login = ({ history }) => {
  const error = useSelector((state) => state.Auth.error);
  const success = useSelector((state) => state.Auth.success);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(authActions.resetMessages());
  }, []);

  const handleValidSubmit = ({ email, password }) => {
    dispatch(authActions.loginWithEmail(email, password, history));
  };

  return (
    <div className="home" style={{ minHeight: '100vh', background: '#fff' }}>
      <Container>
        <Row
          className="align-items-center"
          style={{ minHeight: 'calc(100vh - 80px)' }}>
          <Col
            lg={6}
            className="d-none d-lg-flex justify-content-center align-items-center"
            style={{ background: '#f7fafc', minHeight: '70vh' }}>
            <img
              src={heroImg}
              alt="Telemedicina"
              style={{ maxWidth: '80%', height: 'auto' }}
            />
          </Col>
          <Col
            lg={6}
            md={12}
            className="d-flex flex-column justify-content-center align-items-center"
            style={{ padding: '3rem 1rem' }}>
            <Link to="/index">
              <img
                src={logo}
                alt="SOS Dottore"
                style={{ maxWidth: 220, marginBottom: 32 }}
              />
            </Link>
            <h1
              style={{
                fontSize: '2.5rem',
                fontWeight: 700,
                color: '#22313f',
                textAlign: 'center',
                marginBottom: 8,
              }}>
              Accedi al tuo account
            </h1>
            <p
              style={{
                fontSize: '1.15rem',
                color: '#4a5a6a',
                marginBottom: 32,
                textAlign: 'center',
                maxWidth: 400,
              }}>
              Inserisci le tue credenziali per accedere ai servizi di
              telemedicina SOS Dottore
            </p>
            <div style={{ width: '100%', maxWidth: 400 }}>
              <Form
                className="form-horizontal"
                initialValues={INITIAL_VALUES}
                onSubmit={handleValidSubmit}
                validationSchema={yup.object().shape({
                  email: yup.string().email().required(),
                  password: yup.string().required(),
                })}>
                {error !== '' && <Alert color="danger">{error}</Alert>}
                {success !== '' && <Alert color="success">{success}</Alert>}
                <div className="form-group">
                  <Field
                    name="email"
                    label="Email"
                    className="form-control"
                    placeholder="Inserisci la tua email"
                    type="email"
                  />
                </div>
                <div className="form-group">
                  <Field
                    name="password"
                    label="Password"
                    type="password"
                    className="form-control"
                    placeholder="Inserisci la password"
                  />
                </div>
                <button
                  className="btn btn-primary btn-block"
                  type="submit"
                  style={{
                    padding: '0.75rem',
                    fontSize: '1.15rem',
                    fontWeight: 600,
                    borderRadius: 8,
                    background: '#1e6f5c',
                    border: 'none',
                  }}>
                  Accedi
                </button>
                <div className="text-center mt-4">
                  <Link
                    to="/forgot-password"
                    style={{
                      color: '#1e6f5c',
                      fontWeight: 500,
                      textDecoration: 'underline',
                    }}>
                    Hai dimenticato la password?
                  </Link>
                </div>
                <div className="text-center mt-3">
                  <span style={{ color: '#4a5a6a', fontSize: '1rem' }}>
                    Non hai un account?{' '}
                    <Link
                      to="/register"
                      style={{ color: '#1e6f5c', fontWeight: 600 }}>
                      Registrati
                    </Link>
                  </span>
                </div>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
      <Footer />
    </div>
  );
};

export default withRouter(Login);
